import React from 'react'
import ReactDOM from 'react-dom/client'
import { MantineProvider, createTheme } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { OIDCAuthProvider, AuthProvider, AuthGuard, shouldSkipAuth } from './auth'
import App from './App.tsx'
import '@mantine/core/styles.css'
import '@mantine/dropzone/styles.css'
import '@mantine/notifications/styles.css'
import './styles/app.fonts.css'
import './styles/color.vars.css'
import './styles/mantine.overrides.css'
import './styles/form-inputs.css'
import './index.css'

const theme = createTheme({
  fontFamily: 'proxima-nova, sans-serif',
  primaryColor: 'happyNavy',
  colors: {
    // HappyCo Brand Navy
    happyNavy: [
      'var(--mantine-color-blue-0)',
      'var(--mantine-color-blue-1)',
      'var(--mantine-color-blue-2)',
      'var(--mantine-color-blue-3)',
      'var(--mantine-color-blue-4)',
      'var(--mantine-color-blue-5)',
      'var(--mantine-color-blue-6)',
      'var(--mantine-color-blue-7)',
      'var(--mantine-color-blue-8)',
      'var(--mantine-color-blue-9)',
    ],
    // HappyCo Brand Teal
    happyTeal: [
      '#f0fdf9',
      '#ecfdf5',
      '#d1fae5',
      '#a7f3d0',
      '#6ee7b7',
      '#34d399',
      '#B3EDDC',
      '#10b981',
      '#059669',
      '#047857',
    ],
    gray: [
      'var(--mantine-color-gray-0)',
      'var(--mantine-color-gray-1)',
      'var(--mantine-color-gray-2)',
      'var(--mantine-color-gray-3)',
      'var(--mantine-color-gray-4)',
      'var(--mantine-color-gray-5)',
      'var(--mantine-color-gray-6)',
      'var(--mantine-color-gray-7)',
      'var(--mantine-color-gray-8)',
      'var(--mantine-color-gray-9)',
    ],
  },
})

function AppWrapper() {
  if (shouldSkipAuth()) {
    return <App />
  }

  return (
    <OIDCAuthProvider>
      <AuthProvider>
        <AuthGuard>
          <App />
        </AuthGuard>
      </AuthProvider>
    </OIDCAuthProvider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Notifications />
      <AppWrapper />
    </MantineProvider>
  </React.StrictMode>,
)